import React, { useState, useEffect, useContext } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import { getDataWithToken } from "../../services/GetDataService";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useParams, useNavigate } from "react-router-dom";
import UserBasicInformation from "./UserBasicInformation";
import { useSnackbar } from "notistack";
import UserAccountDetails from "./UserAccountDetails";
import UserLimits from "./UserLimits";
import UserKYCDocument from "./UserKYCDocument";
import Transaction from "./Transaction";
import UserInfoPDF from "./UserInfoPDF";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import PulseLoader from "react-spinners/PulseLoader";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import PersonIcon from "@mui/icons-material/Person";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SupportActivityLogs from "./SupportActivityLogs";
import CustomerActivityLog from "./CustomerActivityLog";

const useStyles = makeStyles((theme) => ({
  centerSelectStyle: {
    [`& .MuiInputLabel-outlined.MuiInputLabel-shrink`]: {
      display: "none",
    },
  },
  tableBodyStyle: {
    "& tr:nth-of-type(odd)": {
      background: "#efefef",
    },
    "& tr:last-child": {
      background: "none",
    },
    "& tr:hover": {
      cursor: "pointer",
      background: "#DCDCDC",
    },
    "& tr:last-child:hover": {
      cursor: "default",
      background: "none",
    },

    [theme.breakpoints.down("xl")]: {
      "& td": {
        paddingTop: "12px",
        paddingBottom: "12px",
      },
    },
  },
  tableHeadStyle: {
    background: "#00848A",
    "& th": {
      color: "#fff",
      fontSize: "16px",
    },
  },
}));

export default function UserDetail({ rollPermission }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xl"));
  const { slug } = useParams();
  const { fastpay_support_panel_user } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [value, setValue] = React.useState("1");
  const [userInfo, setUserInfo] = useState({});
  const [userStatus, setUserStatus] = useState(false);
  const [levelName, setLevelName] = useState("");
  const [level, setLevel] = useState([]);
  const [levelId, setLevelId] = useState("");
  const [levelMessage, setLevelMessage] = useState("");
  const [userInfoMessage, setUserInfoMessage] = useState("");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [DOB, setDOB] = React.useState(new Date());
  const [businessName, setBusinessName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [fullname, setFullname] = useState("");
  const [documentId, setDocumentId] = useState("");
  const [documentLoading, setDocumentLoading] = useState(false);
  const [reactiveLoading, setReactiveLoading] = useState(false);
  const [openReactiveDialog, setOpenReactiveDialog] = useState(false);
  const [reativateReason, setReativateReason] = useState("");

  const handleReactiveDialogOpen = () => {
    setOpenReactiveDialog(true);
  };

  const handleReactiveDialogClose = () => {
    setOpenReactiveDialog(false);
  };
  const handleDateChange = (newValue) => {
    setDOB(newValue);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const getDataAfterStatusUpdate = async () => {
    try {
      setLoading(true);
      let urlParameter;

      let checkText = slug.slice(0, 4);

      if (checkText === "+964") {
        urlParameter = `?mobile_number=${encodeURIComponent(slug)}`;
      } else {
        urlParameter = `?email=${encodeURIComponent(slug)}`;
      }

      let url = `api/customer-info${urlParameter}`;

      let userInfoResponse = await getDataWithToken(url);

      if (userInfoResponse.status === 200) {
        setUserInfo(userInfoResponse.data.data);
        setFirstName(userInfoResponse.data.data.update_keys.first_name);
        setLastName(userInfoResponse.data.data.update_keys.last_name);
        setEmail(userInfoResponse.data.data.update_keys.email);
        setFullname(userInfoResponse.data.data.update_keys?.full_name);
        setBusinessName(userInfoResponse.data.data.update_keys?.business_name);
        setDOB(userInfoResponse.data.data.update_keys?.date_of_birth);
        setDocumentId(userInfoResponse.data.data.update_keys?.document_id);
        // setLevelId(userInfoResponse.data.data.basic_information.level_id);
        setLevelName(userInfoResponse.data.data.basic_information.level);
        if (userInfoResponse.data.data.basic_information.is_active === 1) {
          setUserStatus(true);
        } else {
          setUserStatus(false);
        }
      } else {
        setUserInfoMessage(userInfoResponse.data.messages.toString());
        if (userInfoResponse.data.messages.length < 1) {
          setUserInfoMessage("Something went wrong");
        }
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setUserInfoMessage(error.response.data.messages.toString());
      if (error.response.data.messages.length < 1) {
        setUserInfoMessage("Something went wrong");
      }
      setLoading(false);
    }
    setLoading(false);
  };
  const getDropdownData = async () => {
    setLoading(true);
    setLoading2(true);

    let urlParameter;

    let checkText = slug.slice(0, 4);

    if (checkText === "+964") {
      urlParameter = `?mobile_number=${encodeURIComponent(slug)}`;
    } else {
      urlParameter = `?email=${encodeURIComponent(slug)}`;
    }
    let url = `api/customer-info${urlParameter}`;

    let userInfoResponse = await getDataWithToken(url);

    if (userInfoResponse.status === 200) {
      setUserInfo(userInfoResponse.data.data);
      setFirstName(userInfoResponse.data.data.update_keys.first_name);
      setLastName(userInfoResponse.data.data.update_keys.last_name);
      setEmail(userInfoResponse.data.data.update_keys.email);
      setFullname(userInfoResponse.data.data.update_keys?.full_name);
      setBusinessName(userInfoResponse.data.data.update_keys?.business_name);
      setDOB(userInfoResponse.data.data.update_keys?.date_of_birth);
      setDocumentId(userInfoResponse.data.data.update_keys?.document_id);
      // setLevelId(userInfoResponse.data.data.basic_information.level_id);
      setLevelName(userInfoResponse.data.data.basic_information.level);
      if (userInfoResponse.data.data.basic_information.is_active === 1) {
        setUserStatus(true);
      } else {
        setUserStatus(false);
      }
    } else {
      setUserInfoMessage(userInfoResponse.data.messages.toString());
      if (userInfoResponse.data.messages.length < 1) {
        setUserInfoMessage("Something went wrong");
      }
      setLoading(false);
    }
    setLoading(false);
    // ================================Level======================

    let userLevelResponse = await getDataWithToken(
      `/api/levels?user_type_id=${userInfoResponse.data.data.basic_information.user_type_id}`
    );
    if (userLevelResponse.status === 200) {
      setLevel(userLevelResponse.data.data);
    } else {
      setLevelMessage(userLevelResponse.data.messages.toString());

      if (userLevelResponse.data.messages.length < 1) {
        setLevelMessage("Something went wrong");
      }
    }

    setLoading2(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    let dateCheck = moment(DOB).format("YYYY-MM-DD");
    if (dateCheck === "Invalid date") {
      setDOB(userInfo.update_keys?.date_of_birth);
    }
    setOpen(false);
  };
  const onInfoUpdate = async () => {
    setDocumentLoading(true);
    try {
      console.log("DOB", DOB);
      let dateCheck = moment(DOB).format("YYYY-MM-DD");
      if (DOB !== null && dateCheck === "Invalid date") {
        handleSnakbarOpen("Invalid date", "error");
        document.getElementById("dob").focus();
      } else {
        let data = {
          kyc_id:
            userInfo?.update_keys?.kyc_id !== null
              ? userInfo?.update_keys?.kyc_id
              : "",
          business_name:
            userInfo?.update_keys?.user_type_id === 2 ? businessName : "",
          document_number:
            userInfo?.update_keys?.status_editable === 1 ? documentId : "",

          first_name: firstName,
          last_name: lastName,

          full_name: fullname,
          date_of_birth: DOB !== null ? moment(DOB).format("YYYY-MM-DD") : null,
          user_id: userInfo.update_keys.user_id,
        };

        if (userInfo?.update_keys?.email_editable === 1) {
          data = { ...data, email: email };
        }

        let response = await axios({
          url: "api/customer-info-update",
          method: "post",
          data: data,
          headers: {
            Authorization: `Bearer ${fastpay_support_panel_user.token}`,
          },
        });
        if (response.status === 200) {
          handleSnakbarOpen(response.data.messages.toString(), "success");
          getDataAfterStatusUpdate();

          setOpen(false);
        }
      }
    } catch (error) {
      console.log("error", error);
      handleSnakbarOpen(error.response.data.messages.toString(), "error");
      if (error.response.data.messages.length < 1) {
        handleSnakbarOpen("Something went wrong", "error");
      }
      setDocumentLoading(false);
    }
    setDocumentLoading(false);
  };

  const onReactiveUser = async () => {
    setReactiveLoading(true);
    try {
      let data = {
        user_id: userInfo.basic_information.user_id,
        reason: reativateReason,
      };

      let response = await axios({
        url: "api/customer-reactivate",
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${fastpay_support_panel_user.token}`,
        },
      });
      if (response.status === 200) {
        handleSnakbarOpen(response.data.messages.toString(), "success");
        getDataAfterStatusUpdate();
        setReativateReason("");
        setOpenReactiveDialog(false);
      }
    } catch (error) {
      console.log("error", error);
      handleSnakbarOpen(error.response.data.messages.toString(), "error");
      if (error.response.data.messages.length < 1) {
        handleSnakbarOpen("Something went wrong", "error");
      }
      setReactiveLoading(false);
    }
    setReactiveLoading(false);
  };
  const navigateToCreateTicket = () => {
    navigate(`/create-ticket/${userInfo.basic_information.mobile_number}`);
  };
  useEffect(() => {
    getDropdownData();
  }, []);
  return (
    <>
      <TableContainer
        component={Paper}
        style={{ padding: "0px 16px 16px", boxSizing: "border-box" }}
      >
        <Grid container columnSpacing={3} style={{ padding: "16px 0" }}>
          <Grid item lg={4} xl={4}>
            <Typography variant="h4" color="info" gutterBottom component="div">
              User's Details
            </Typography>
          </Grid>
          {Object.entries(userInfo).length !== 0 && (
            <Grid item lg={8} xl={8}>
              <Grid container justifyContent="right" alignItems="center">
                {rollPermission?.includes("Customer reactivation") && (
                  <>
                    <Button
                      disableElevation
                      variant="outlined"
                      size={matches ? "small" : "large"}
                      color="warning"
                      startIcon={<PersonIcon />}
                      style={{ color: "#73950c", border: "1px solid #73950c" }}
                      onClick={handleReactiveDialogOpen}
                    >
                      Reactivate User
                    </Button>{" "}
                    &nbsp;&nbsp;&nbsp;
                  </>
                )}
                <UserInfoPDF customerInfo={userInfo} />
                &nbsp;&nbsp;&nbsp;{" "}
                <Button
                  disableElevation
                  variant="outlined"
                  size={matches ? "small" : "large"}
                  color="success"
                  startIcon={<EditIcon />}
                  onClick={handleClickOpen}
                >
                  Update Info
                </Button>
                {rollPermission?.includes("Create ticket") && (
                  <>
                    &nbsp;&nbsp;&nbsp;
                    <Button
                      disableElevation
                      variant="outlined"
                      size={matches ? "small" : "large"}
                      color="info"
                      startIcon={<AddIcon />}
                      onClick={navigateToCreateTicket}
                    >
                      Create Ticket
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>

        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="fullWidth"
            >
              <Tab
                style={{ fontWeight: 600 }}
                label="BASIC INFORMATION"
                value="1"
              />
              {rollPermission?.includes("View account details") && (
                <Tab
                  style={{ fontWeight: 600 }}
                  label="ACCOUNT DETAILS"
                  value="2"
                />
              )}
              {rollPermission?.includes("View kyc document") && (
                <Tab
                  style={{ fontWeight: 600 }}
                  label="KYC DOCUMENT"
                  value="3"
                />
              )}
              {rollPermission?.includes("Customer transaction search") && (
                <Tab
                  style={{
                    fontWeight: 600,
                  }}
                  label="TRANSACTION"
                  value="4"
                />
              )}
              {rollPermission?.includes("View customer limit") && (
                <Tab style={{ fontWeight: 600 }} label="LIMITS" value="5" />
              )}
              {rollPermission?.includes("Support activity log") && (
                <Tab
                  style={{ fontWeight: 600 }}
                  label="Support Activity Log"
                  value="6"
                />
              )}
              {rollPermission?.includes("Customer activity log") && (
                <Tab
                  style={{ fontWeight: 600 }}
                  label="Customer Activity Log"
                  value="7"
                />
              )}
            </TabList>
          </Box>

          <TabPanel
            value="1"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
          >
            <UserBasicInformation
              basicInformation={userInfo.basic_information}
              updateKeys={userInfo.update_keys}
              businessInformation={userInfo.business_information}
              loading={loading}
              userStatus={userStatus}
              setUserStatus={setUserStatus}
              levelName={levelName}
              setLevelName={setLevelName}
              level={level}
              levelId={levelId}
              setLevelId={setLevelId}
              userInfoMessage={userInfoMessage}
              rollPermission={rollPermission}
            />
          </TabPanel>
          <TabPanel
            value="2"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
          >
            <UserAccountDetails
              accountDetails={userInfo.account}
              loading={loading}
              userInfoMessage={userInfoMessage}
            />
          </TabPanel>
          <TabPanel
            value="3"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
          >
            <UserKYCDocument
              basicInformation={userInfo.basic_information}
              KYCInfo={userInfo.kyc}
              loading={loading}
              level={level}
              levelId={levelId}
              userInfoMessage={userInfoMessage}
              getDataAfterStatusUpdate={getDataAfterStatusUpdate}
              rollPermission={rollPermission}
            />
          </TabPanel>
          <TabPanel
            value="4"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
          >
            <Transaction
              rollPermission={rollPermission}
              mobileNo={userInfo?.basic_information?.mobile_number}
              userInfoMessage={userInfoMessage}
            />
          </TabPanel>
          <TabPanel
            value="5"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
          >
            {" "}
            <UserLimits
              mobileNo={userInfo?.basic_information?.mobile_number}
              userInfoMessage={userInfoMessage}
            />
          </TabPanel>
          <TabPanel
            value="6"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
          >
            {" "}
            <SupportActivityLogs
              basicInformation={userInfo?.basic_information}
              userInfoMessage={userInfoMessage}
            />
          </TabPanel>
          <TabPanel
            value="7"
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
          >
            {" "}
            <CustomerActivityLog
              basicInformation={userInfo.basic_information}
              userId={userInfo?.basic_information?.user_id}
              userInfoMessage={userInfoMessage}
              rollPermission={rollPermission}
            />
          </TabPanel>
        </TabContext>
      </TableContainer>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"lg"}
      >
        <DialogContent style={{ minWidth: "500px", maxWidth: "500px" }}>
          <Typography
            variant="h5"
            component="div"
            style={{ marginBottom: "30px", textAlign: "center" }}
          >
            Update Personal Info
          </Typography>

          <Grid container spacing={2}>
            {userInfo?.update_keys?.user_type_id === 2 && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="outlined-basic"
                  label="Business Name"
                  variant="outlined"
                  fullWidth
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField
                size="small"
                id="outlined-basic"
                label="First Name"
                variant="outlined"
                fullWidth
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                id="outlined-basic"
                label="Last Name"
                variant="outlined"
                fullWidth
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                size="small"
                id="outlined-basic"
                label="Full Name"
                variant="outlined"
                fullWidth
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
              />
            </Grid>
            {userInfo?.update_keys?.email_editable === 1 && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="outlined-basic"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="Date of Birth"
                  inputFormat="yyyy/MM/dd"
                  value={DOB}
                  onChange={handleDateChange}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small" id="dob" />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            {userInfo?.update_keys?.status_editable === 1 && (
              <Grid item xs={12}>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  label="Document ID"
                  fullWidth
                  value={documentId}
                  onChange={(e) => setDocumentId(e.target.value)}
                />{" "}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: "0px 24px 16px" }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            color="primary"
            style={{ minWidth: "120px" }}
            // size="small"
            variant="contained"
            disabled={documentLoading}
            disableElevation
            onClick={onInfoUpdate}
            // startIcon={<SaveIcon size="small" />}
          >
            {/* <SendIcon size="small" /> */}
            <PulseLoader
              color={"#00848A"}
              loading={documentLoading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
            {documentLoading === false && "Update"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openReactiveDialog}
        onClose={handleReactiveDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"lg"}
      >
        <DialogContent style={{ minWidth: "500px", maxWidth: "500px" }}>
          <Typography
            variant="h5"
            component="div"
            style={{ marginBottom: "5px", textAlign: "center" }}
          >
            Reactivate User
          </Typography>
          <Typography
            variant="h6"
            component="div"
            style={{
              marginBottom: "20px",
              textAlign: "center",
              color: "#818181",
            }}
          >
            {userInfo?.basic_information?.name}&nbsp;(
            {userInfo?.basic_information?.mobile_number})
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                size="small"
                id="outlined-basic"
                label="Reativate Reason"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={reativateReason}
                onChange={(e) => setReativateReason(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: "0px 24px 16px" }}>
          <Button onClick={handleReactiveDialogClose}>Cancel</Button>
          <Button
            color="primary"
            style={{ minWidth: "120px" }}
            // size="small"
            variant="contained"
            disabled={reactiveLoading}
            disableElevation
            onClick={onReactiveUser}
          >
            <PulseLoader
              color={"#00848A"}
              loading={reactiveLoading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
            {reactiveLoading === false && "Reactive"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
